import { render, staticRenderFns } from "./VerifyPhone.vue?vue&type=template&id=91f228aa&scoped=true&"
import script from "./VerifyPhone.vue?vue&type=script&lang=js&"
export * from "./VerifyPhone.vue?vue&type=script&lang=js&"
import style0 from "./VerifyPhone.vue?vue&type=style&index=0&id=91f228aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f228aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91f228aa')) {
      api.createRecord('91f228aa', component.options)
    } else {
      api.reload('91f228aa', component.options)
    }
    module.hot.accept("./VerifyPhone.vue?vue&type=template&id=91f228aa&scoped=true&", function () {
      api.rerender('91f228aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/VerifyPhone.vue"
export default component.exports